// extracted by mini-css-extract-plugin
export var addViewLink = "_s-1";
export var availabilityIcon = "_s-16";
export var availabilitySelectionIcon = "_s-15";
export var backButton = "_s-2";
export var backIcon = "_s-z";
export var conversationCount = "_s-3";
export var dragHandle = "_s-5";
export var dropdown = "_s-e";
export var dropdownIcon = "_s-7";
export var dropdownOption = "_s-6";
export var dropdownTriangle = "_s-d";
export var expand = "_s-f";
export var folder = "_s-i";
export var folderItem = "_s-c";
export var icon = "_s-8";
export var iconRow = "_s-9";
export var image = "_s-a";
export var logo = "_s-b";
export var navContainer = "_s-h";
export var navigationFooter = "_s-g";
export var pageShell = "_s-0";
export var placeholderAvailable = "_s-11";
export var placeholderBox = "_s-14";
export var placeholderBusy = "_s-13";
export var placeholderUnavailable = "_s-12";
export var profile = "_s-k";
export var profileContainer = "_s-m";
export var profileDropdown = "_s-n";
export var profileImage = "_s-l";
export var profileMain = "_s-o";
export var profileSubtitle = "_s-q";
export var profileTitle = "_s-p";
export var reorderIcon = "_s-r";
export var sentLine = "_s-u";
export var settingsHeader = "_s-s";
export var sidenavTextColor = "_s-y";
export var spamLine = "_s-t";
export var subitemWithTag = "_s-4";
export var supportItems = "_s-j";
export var teamText = "_s-10";
export var viewLine = "_s-x";
export var viewLineButton = "_s-w";
export var viewLineButtons = "_s-v";